import { EventDragCreate, GridFeatureManager } from "@bryntum/schedulerpro";
import type { FinalizeContext } from "./FinalizeContext";
import ProjectQueueHoldMixin from "./mixins/ProjectQueueHoldMixin";

/**
 * Replaces Bryntum's default `EventDragCreate` feature for `SchedulerPro`.
 *
 * Holds `project.crudQueue.queue()` from drag-create start through finalization, so
 * CRUD work queued during the gesture waits behind it. Invalid drops, aborts and
 * teardown release the hold without finalization work.
 *
 * Bryntum's default feature hands control to `EventEdit` in Scheduler and `TaskEdit`
 * in SchedulerPro. This application disables `taskEditorFeature`, so no editor
 * handover occurs and drag-create can safely release the queue lock itself.
 */
export default class SwivuEventDragCreate extends ProjectQueueHoldMixin(EventDragCreate) {
  static $name = "EventDragCreate";

  construct(...args: object[]) {
    super.construct(...args);

    this.client.on({
      dragCreateStart: () => this.holdProjectQueue(),
      beforeDragCreateFinalize: ({ context }: { context: FinalizeContext }) => {
        context.async = true;
        this.runWithProjectQueue(() => context.finalize(true));
      },
      afterDragCreate: () => this.cancelProjectQueue(),
      thisObj: this
    });
  }
}

GridFeatureManager.registerFeature(SwivuEventDragCreate, true, "SchedulerPro");
